<script>
  import { isValidRegex, escapeRegExp } from "../../../../lib/util/regex";
  import { fetchWithSession } from "../../../../lib/util/fetchWithSession";
  import { SectionWrapper } from "paxray-components-svelte";
  import MultiSelect from "../../../../lib/components/MultiSelect.svelte";
  import Header from "../../../../lib/components/Header.svelte";
  import ContentSwitcher from "lib/components/ContentSwitcher.svelte";

  import {
    DataTable,
    DataTableSkeleton,
    Pagination,
    TextInput,
    Checkbox,
    Modal as DangerModal,
    Toolbar,
    ToolbarContent,
    ToolbarSearch,
  } from "carbon-components-svelte";
  import ButtonNew from "../../../../lib/components/ButtonNew.svelte";
  import Modal from "../../../../lib/components/Modal.svelte";
  import Select from "@components/common/forms/Select.svelte";

  const urlParams = new URLSearchParams(window.location.search);
  let idAnonymization;
  let idproject = urlParams.get("idproject");
  let anonymizationstep = urlParams.get("step") || 1;
  let selectedIndex = 0;
  let selectedPreview = 0;

  let headers = [
    { key: "string", value: "String" },
    { key: "type", value: "Type" },
    { key: "hidden", value: "NOT Relevant" },
    { key: "rulecreated", value: "Rule created" },
  ];

  let onlyRelevant = false;
  let onlyRuleCreated = false;
  let onlyNotRelevant = false;
  let onlyNotRuleCreated = false;
  let loading = true;
  let selectedIds = [];
  let filteredRowIds = [];

  let openModal = false;
  let openDangerModal = false;
  let openDangerModalGenerate = false;
  let selectedRowIds = [];
  let rows = [];
  let anonymizationtype = "anonymization";
  let anonymizationtypes = ["anonymization", "anonymization_ui"];
  let listtype = "am_windowtitle";

  let allRows;
  let pagination = {
    page: 1,
    pageSize: 10,
    total: 0,
    totalPages: 0,
  };

  let type = "";
  let rowId;
  let namePrefix = "0 - AUTORULE -";
  let projectstepid = "";
  let typeOptions = [];
  let multiSelectItems = [];
  let listOfElements = [];
  let invalidInputs = {};
  let searchValue = "";

  $: idAnonymization = getIdAnonymization(idproject);

  $: {
    if (selectedIndex === 1) listtype = "ui_name";
    else listtype = "am_windowtitle";
    updateTable(selectedPreview);
  }

  $: {
    invalidInputs = {};
    listOfElements.forEach((element) => {
      invalidInputs[element.type] = !isValidRegex(element.value);
    });
  }

  function updateTable(selectedPreview) {
    getAnonymizationCandidates();
  }

  function generateAnonymizationCandidates() {
    loading = true;
    fetchWithSession(
      `/api/damprojects/generateAnonymizationCandidates?idproject=${idproject}&type=${anonymizationtypes[selectedIndex]}&projectstep=${anonymizationstep}&preview=${selectedPreview}`
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.result === "error") {
          console.log("Error", data.message);
          loading = false;
          return;
        }
        // rows = data.map((item, index) => ({
        //   id: index + 1,
        //   string: item[0],
        //   type:
        //     item[1].toUpperCase() === "ORGANISATION"
        //       ? "Company"
        //       : item[1].charAt(0).toUpperCase() +
        //         item[1].slice(1).toLowerCase(),
        //   hidden: item["hidden"],
        //   rulecreated: item["rulecreated"],
        // }));
        // allRows = rows;
        //projectstepid = data[0].projectstepid;
        loading = false;
        openDangerModalGenerate = false;
      });
  }

  function getAnonymizationCandidates() {
    loading = true;
    fetchWithSession(
      `/api/damprojects/getAnonymizationCandidates?idproject=${idproject}&type=${listtype}&projectstep=${anonymizationstep}&preview=${selectedPreview}`
    )
      .then((res) => res.json())
      .then((data) => {
        const sortedData = data.sort((a, b) => a.name.localeCompare(b.name));
        rows = sortedData
          .map((item, index) => ({
            id: index + 1,
            string: item["name"],
            type: item["type"].toUpperCase(),
            hidden: item["hidden"],
            rulecreated: item["rulecreated"],
          }))
          .filter((item) => item.string.length >= 3);
        const types = [
          ...new Set(sortedData.map((item) => item["type"].toUpperCase())),
        ];
        typeOptions = types.map((type) => ({
          name: type,
          value: type,
        }));
        multiSelectItems = types.map((type, index) => ({
          id: (index + 1).toString(),
          text: type,
        }));
        allRows = rows;
        if (sortedData.length > 0) projectstepid = sortedData[0].projectstepid;
        loading = false;
      });
  }

  function getIdAnonymization(idproject) {
    fetchWithSession(`/api/damprojects/getProjectAnonymizations/${idproject}/2`)
      .then((res) => res.json())
      .then((data) => {
        idAnonymization = data;
      });
  }

  function createRules() {
    listOfElements.forEach((element) => {
      if (!isEmpty(element.value)) {
        const dataRule = {
          id: 0,
          search: element.value,
          replace: element.type.toUpperCase(),
          applicationname: "",
          name: namePrefix + " " + element.type.toUpperCase(),
        };
        addNewRule(dataRule);
      }
    });
    const updateRows = rows
      .filter((row) => selectedRowIds.includes(row.id))
      .map((row) => ({
        name: row.string,
        update_columns: {
          hidden: row.hidden,
          rulecreated: true,
        },
      }));
    const rowsToUpdate = {
      type: listtype,
      idprojectstep: projectstepid,
      update_rows: updateRows,
    };
    updateRuleCreated(rowsToUpdate);
  }

  function addNewRule(ruleData) {
    let payload = {
      idanonymizationrules: idAnonymization,
      ...ruleData,
    };
    let url = `/api/damprojects/saveDAMAnonymizationRule?preset=false`;

    if (selectedIndex) {
      payload = {
        applicationname: ruleData.applicationname,
        automationreplace: "",
        automationsearch: "",
        elementclass: "",
        id: ruleData.id,
        idanonymizationrules: idAnonymization,
        name: ruleData.name,
        namereplace: ruleData.replace,
        namesearch: ruleData.search,
      };
      url = `/api/damprojects/saveDAMAnonymizationRuleUI`;
    }

    fetchWithSession(url, {
      method: "POST",
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("Rule created", { data });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function updateRuleCreated(rowsToUpdate) {
    fetchWithSession(
      `/api/damprojects/updateAnonymizationCandidates?preview=${selectedPreview}`,
      {
        method: "POST",
        body: JSON.stringify(rowsToUpdate),
      }
    )
      .then((res) => res.json())
      .then((data) => {
        getAnonymizationCandidates();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function hiddeRow(row) {
    let payload = {
      type: listtype,
      idprojectstep: projectstepid,
      update_rows: [
        {
          name: row.string,
          update_columns: {
            hidden: row.hidden,
            rulecreated: row.rulecreated,
          },
        },
      ],
    };

    fetchWithSession(
      `/api/damprojects/updateAnonymizationCandidates?preview=${selectedPreview}`,
      {
        method: "POST",
        body: JSON.stringify(payload),
      }
    )
      .then((res) => res.json())
      .then((data) => {
        allRows = allRows.map((r) =>
          r.id === row.id ? { ...r, hidden: row.hidden } : r
        );
        applyFilters();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function applyFilters() {
    let temp = allRows;

    if (selectedIds.length > 0) {
      let selectedTypes = selectedIds
        .map((id) => multiSelectItems.find((item) => item.id === id)?.text)
        .filter(Boolean);
      temp = temp.filter((row) => selectedTypes.includes(row.type));
    }
    if (onlyRelevant) temp = temp.filter((row) => row.hidden === false);
    if (onlyNotRelevant) temp = temp.filter((row) => row.hidden);
    if (onlyRuleCreated) temp = temp.filter((row) => row.rulecreated);
    if (onlyNotRuleCreated)
      temp = temp.filter(
        (row) => row.rulecreated === false || row.rulecreated === null
      );
    if (searchValue) {
      temp = temp.filter((row) =>
        row.string.toLowerCase().includes(searchValue.toLowerCase())
      );
    }
    rows = temp;
    filteredRowIds = temp.map((row) => row.id);
  }

  function handleOpenModal() {
    listOfElements = getDynamicGroups();
    openModal = !openModal;
  }

  function handleTypeChange(value, id) {
    type = value;
    rowId = id;
    const row = rows.find((row) => row.id === id);
    if (row) {
      row.type = value;
      rows = [...rows];
    }
  }

  function getDynamicGroups() {
    const grouped = {};

    selectedRowIds.forEach((id) => {
      const row = rows.find((row) => row.id === id);
      if (!row) return;

      const type = row.type;
      if (!grouped[type]) {
        grouped[type] = [];
      }

      grouped[type].push(escapeRegExp(row.string));
    });

    return Object.entries(grouped).map(([type, values]) => ({
      type,
      value: `(${values.sort((a, b) => b.length - a.length).join("|")})`,
    }));
  }

  function isEmpty(string) {
    return string === "()" || string === "";
  }

  function setItemType(itemType) {
    if (itemType === "PERSON") {
      return "NAME";
    } else if (itemType === "ORGANISATION") {
      return "COMPANY";
    }
    return itemType;
  }
  $$restProps;
</script>

<Header section="Anonymization" breadcrumb="Assistant">
  <ButtonNew
    text="Generate Anonymization Candidates"
    setting
    secondary
    on:click={() => {
      openDangerModalGenerate = true;
    }}
  ></ButtonNew>
</Header>

<SectionWrapper fullscreen={true}>
  <div class="main" slot="main">
    <div class="switcher">
      <ContentSwitcher
        bind:selected={selectedIndex}
        options={["WindowTitle", "UI Elements"]}
        fitContent={true}
      />
      <ContentSwitcher
        bind:selected={selectedPreview}
        options={["Raw", "Preview"]}
        fitContent={true}
      />
    </div>
    <div class="table_wrapper">
      <div class="multiselect-wrapper">
        {#key multiSelectItems}
          <MultiSelect
            labelText="Type"
            label="Select Type..."
            items={multiSelectItems}
            bind:selectedIds
            onchange={applyFilters}
          />
        {/key}
      </div>
      <div class="filter_wrapper">
        <div class="filter_col">
          <Checkbox
            bind:checked={onlyRelevant}
            labelText="Show only Relevant"
            on:change={applyFilters}
          />
          <Checkbox
            bind:checked={onlyRuleCreated}
            labelText="Show only Rule Created"
            on:change={applyFilters}
          />
        </div>
        <div class="filter_col">
          <Checkbox
            bind:checked={onlyNotRelevant}
            labelText="Show only NOT Relevant"
            on:change={applyFilters}
          />
          <Checkbox
            bind:checked={onlyNotRuleCreated}
            labelText="Show only NOT Rule Created"
            on:change={applyFilters}
          />
        </div>
      </div>
      {#if loading}
        <DataTableSkeleton rows={10} {headers} showToolbar showHeader={false} />
      {:else}
        <DataTable
          zebra
          batchSelection
          selectable
          {headers}
          {rows}
          sortable
          pageSize={pagination.pageSize}
          page={pagination.page}
          bind:selectedRowIds
        >
          <Toolbar>
            <ToolbarContent>
              <ToolbarSearch
                persistent
                bind:value={searchValue}
                shouldFilterRows={(row, value) => {
                  return true;
                }}
                on:input={() => {
                  applyFilters();
                }}
                on:clear={() => {
                  searchValue = "";
                  applyFilters();
                }}
                bind:filteredRowIds
              />
            </ToolbarContent>
          </Toolbar>
          <svelte:fragment slot="cell" let:row let:cell>
            {#if cell.key === "hidden"}
              <Checkbox
                on:change={(e) => {
                  row.hidden = e.target.checked;
                  hiddeRow(row);
                }}
                checked={row.hidden}
              />
            {:else if cell.key === "rulecreated"}
              <div class="readonly-checkbox">
                <Checkbox readonly hideLabel checked={row.rulecreated} />
              </div>
            {:else if cell.key === "type"}
              <Select
                id="type-{row.id}"
                options={typeOptions}
                placeholder={row.type}
                on:change={(e) => handleTypeChange(e.target.value, row.id)}
              />
            {:else}
              {cell.value}
            {/if}
          </svelte:fragment>
        </DataTable>
        <Pagination
          bind:pageSize={pagination.pageSize}
          bind:page={pagination.page}
          totalItems={rows.length}
          pageSizes={[10, 25, 50, 75, 100]}
        />
      {/if}
    </div>
    <div>
      <ButtonNew
        text="Create Rules from Selected Entries"
        setting
        secondary
        on:click={handleOpenModal}
      ></ButtonNew>
    </div>
  </div>
</SectionWrapper>

<Modal
  open={openModal}
  preventCloseOnClickOutside
  primaryButtonText="Create Rules"
  primaryButtonAction={() => {
    if (listOfElements.length !== 0) openDangerModal = true;
  }}
  secondaryButtonAction={() => (openModal = false)}
  modalHeading="Rule Generation"
  actions
  autowidth
  primaryButtonValidations={listOfElements.length === 0}
  primaryButtonNotAllow={listOfElements.length === 0}
>
  <TextInput bind:value={namePrefix} labelText="Name Prefix" />

  {#if listOfElements.length === 0}
    <p class="no_elements">No elements selected</p>
  {/if}
  {#each listOfElements as element}
    <TextInput
      bind:value={element.value}
      labelText={setItemType(element.type)}
      invalid={invalidInputs[element.type]}
      invalidText="Invalid Regex"
      on:input={() =>
        (invalidInputs[element.type] = !isValidRegex(element.value))}
    />
  {/each}
</Modal>

<DangerModal
  danger
  bind:open={openDangerModal}
  preventCloseOnClickOutside
  modalHeading={`Create Rules from Selected Entries`}
  primaryButtonText="Create Rules"
  secondaryButtonText="Cancel"
  on:click:button--primary={() => {
    openDangerModal = false;
    openModal = false;
    createRules();
  }}
  on:click:button--secondary={() => (openDangerModal = false)}
  on:close={() => (openDangerModal = false)}
>
  <p class="deleteModalBody">
    Do you really want to close this Modal? Selected Entries will be marked as
    created.
    <span>This view cannot be restored easily.</span>
  </p>
</DangerModal>

<DangerModal
  danger
  bind:open={openDangerModalGenerate}
  preventCloseOnClickOutside
  modalHeading={`Generate Anonymization Candidates`}
  primaryButtonText="Generate"
  secondaryButtonText="Cancel"
  on:click:button--primary={generateAnonymizationCandidates}
  on:click:button--secondary={() => (openDangerModalGenerate = false)}
  on:close={() => (openDangerModalGenerate = false)}
>
  <p class="deleteModalBody">
    Do you really want to Generate Anonymization Candidates rules?
    <span>This view cannot be restored easily.</span>
  </p>
</DangerModal>

<style>
  .main {
    max-width: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .table_wrapper {
    display: flex;
    flex-direction: column;
  }

  .filter_wrapper {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    margin-top: 0.5rem;
    margin-bottom: 1rem;
  }

  .multiselect-wrapper {
    display: inline-block;
    max-width: 500px;
  }

  .deleteModalBody {
    padding: 23px 0px 23px 0px;
    font-family: Inter;
    font-size: 14px;
  }
  .deleteModalBody span {
    font-weight: 700;
  }

  .deleteModalBody :last-child {
    color: var(--pax-orange);
  }

  .readonly-checkbox {
    pointer-events: none;
    cursor: not-allowed;
  }

  .no_elements {
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--pax-orange);
    margin-top: 1rem;
    padding-left: 0.5rem;
  }

  .switcher {
    display: flex;
    gap: 1rem;
  }

  :global(.filter_wrapper .bx--form-item.bx--checkbox-wrapper:first-of-type) {
    margin-top: 0 !important;
  }

  :global(.table_wrapper .bx--data-table tbody tr td:nth-child(2)) {
    max-width: 200px;
    white-space: normal;
    word-wrap: break-word;
  }
</style>
